import { Action, getModule, Module, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { ManageAreaComponent } from "@/app/infrastructures/dependencies/modules/ManageAreaComponent";
import { container } from "tsyringe";
import { ManageAreaPresenter } from "../presenters/ManageAreaPresenter";
import {
  ListManageAreaApiRequest,
  ListAvailableCourierApiRequest,
  ListGeoAddressApiRequest,
  TransferAreaApiRequest,
  AvailableGeoAddressApiRequest,
  CreateAreaApiRequest
} from "@/data/payload/api/ManageAreaApiRequest";
import { UpdatePartnerAreaRequestInterface } from '@/data/payload/contracts/ManageAreaRequest';

ManageAreaComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "manage-area"
})
class ManageAreaStore extends VuexModule {
  @Action
  async getList(params: ListManageAreaApiRequest) {
    const presenter = container.resolve(ManageAreaPresenter);
    return presenter.getList(params);
  }

  @Action
  async getSummaryGeoAddress() {
    const presenter = container.resolve(ManageAreaPresenter);
    return presenter.getSummaryGeoAddress();
  }

  @Action
  async getGeoAddress(params: ListGeoAddressApiRequest) {
    const presenter = container.resolve(ManageAreaPresenter);
    return presenter.getGeoAddress(params);
  }

  @Action
  async getAvailableCourier(params: ListAvailableCourierApiRequest) {
    const presenter = container.resolve(ManageAreaPresenter);
    return presenter.getAvailableCourier(params);
  }

  @Action
  async delete(uid: string) {
    const presenter = container.resolve(ManageAreaPresenter);
    return presenter.delete(uid);
  }

  @Action
  async getAvailableGeoAddress(params: AvailableGeoAddressApiRequest) {
    const presenter = container.resolve(ManageAreaPresenter);

    return presenter.getAvailableGeoAddress(params)
  }

  @Action
  async getTransferArea(uid: string) {
    const presenter = container.resolve(ManageAreaPresenter)
    return presenter.getTransferArea(uid)
  }

  @Action
  async postTransferArea(payload: TransferAreaApiRequest) {
    const presenter = container.resolve(ManageAreaPresenter)
    return presenter.postTransferArea(payload)
  }

  @Action
  async createArea(payload: CreateAreaApiRequest) {
    const presenter = container.resolve(ManageAreaPresenter);

    return presenter.createArea(payload);
  }

  @Action
  async getDetail(uid: string) {
    const presenter = container.resolve(ManageAreaPresenter);
    return presenter.getDetail(uid);
  }

  @Action
  async update(payload: {
    uid: string;
    payload: UpdatePartnerAreaRequestInterface;
  }) {
    const presenter = container.resolve(ManageAreaPresenter);
    return presenter.update(payload.uid, payload.payload);
  }
}
export const ManageAreaController = getModule(ManageAreaStore);
